module.exports = __webpack_public_path__ + "assets/active-4352df.svg";